declare global {
    interface Window {
        fbq: any;
    }
}

export const FB_PIXEL_ID = '5305798042780466';

export const pageView = () => {
    window.fbq('track', 'PageView');
};

export const event = (name: string, options = {}) => {
    window.fbq('track', name, options);
};

export const conversion = (name: string, options = {}) => {
    window.fbq('track', name, options);
};
